import { CircularProgress, Stack } from "@mui/material";
import React, { memo } from "react";

/**
 * Loading de página inteira para o legado.
 *
 * Centraliza o fallback de carregamento usado pelo roteamento dinâmico,
 * substituindo o comportamento antigo que vivia dentro de `usePages`.
 */
const FullPageLoading = memo(() => {
  return (
    <Stack
      width="100%"
      height="100vh"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Stack>
  );
});

FullPageLoading.displayName = "FullPageLoading";

export default FullPageLoading;

